import { Endpoint, RecordsForPage } from "../mb_constants";

/**
 * 
 * @param {*} page 
 * @param {*} search 
 * @returns 
 */
const MbApi_TipologyList = async (page, search, getAll = false) => {
    
    try{
        const response = await fetch(
            `${Endpoint}/api/mb/v1/tipology/list?page=${page}&record_for_page=${!getAll ? RecordsForPage : "999999"}${search ? `&search=${search}` : ''}`,
            {
                headers: {
                    'jwt': `Bearer ${localStorage.getItem('jwt')}`
                }
            }
        );

        if(response.status == 200){
            const data = await response.json();
            return data;
        }
    }catch(_){
        
    }

    return null;
};

/**
 * 
 * @param {*} body 
 * @returns 
 */
const MbApi_TipologyCreate = async (body) => {

    const response = await fetch(
        `${Endpoint}/api/mb/v1/tipology/create`,
        {
            method: "POST",
            headers: {
                'jwt': `Bearer ${localStorage.getItem('jwt')}`,
                'Content-Type': "application/json"
            },
            body: body
        }
    );

    try{
        if(response.status == 201){
            const res = await response.json();
            if(res.Result == "OK"){
                return true;
            }
        }
    }catch(_){

    }

    return false;
};

/**
 * 
 * @param {*} id_tipology
 * @returns 
 */
const MbApi_TipologyDelete = async (id_tipology) => {

    const response = await fetch(
        `${Endpoint}/api/mb/v1/tipology/delete?id_tipology=${id_tipology}`,
        {
            method: "DELETE",
            headers: {
                'jwt': `Bearer ${localStorage.getItem('jwt')}`,
                'Content-Type': "application/json"
            }
        }
    );

    try{
        if(response.status == 200){
            const res = await response.json();
            if(res.Result == "OK"){
                return true;
            }
        }
    }catch(_){

    }

    return false;

};

export {
    MbApi_TipologyList,
    MbApi_TipologyCreate,
    MbApi_TipologyDelete
}